import { Component, OnInit, Input} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Urls } from '@root/utils/catalogue/urls';
import { ApiService } from '@shared/catalogue/services/api.service';
import { CommonDataService } from '@shared/catalogue/services/common-data.service';
import { CatalogService } from '@catalog/catalog.service';
import { DATA_PER_PAGE,
         CANCEL,
         Banner_deleted } from '@root/app.constant';

const MAX_FILE_SIZE = 540000;
@Component({
  selector: 'app-banner-list',
  templateUrl: './banner-list.component.html',
  styleUrls: ['./banner-list.component.scss'],
  providers: [CatalogService],
})
export class BannerListComponent implements OnInit{
  @Input() data: any[];

  @Input() selection: string;

  pageSize: number = DATA_PER_PAGE;

  type = 'BANNER';

  sourceType: string
    
  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    private catalogService: CatalogService,
    public commonDataService: CommonDataService
  ) {}

  ngOnInit() {}


  getBanners = (data) => {
      this.apiService.postData(Urls.getBanners, { source: data.isWebBanner === true ? 'W' : 'M', bannerType: data.bannerType }).subscribe(
        response => {
          if(response.status === 0){
            this.data = [...response.data.banners];
          }else{
            this.data = [];
          }
        },
        error=> {
          this.data = [];
        }
      )
  };

  viewFile = (path) => {
    window.open(path, '_blank');
  };

  deleteFile = (data) => {
    const obj = {
      id: data.id,
      bannerType: data.bannerType,
    };
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteBanners, obj)
            .subscribe((response: any) => {
              this.getBanners(data);
            });
          this.toastr.success(Banner_deleted);
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  };
}
